var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amusnet-jackpot"},[_c('iframe',{attrs:{"frameborder":"0","width":"100%","src":_vm.cdn_url + '/jackpot/amusnet/' + _vm.domain_id + '/index.html?2'}})])}
var staticRenderFns = []

export { render, staticRenderFns }